/* eslint-disable prefer-template */

const serverBaseUrl = process.env.REACT_APP_SERVER_HOSTNAME
  ? process.env.REACT_APP_SERVER_HOSTNAME +
    (process.env.REACT_APP_SERVER_PORT ? ':' + process.env.REACT_APP_SERVER_PORT : '')
  : window.location.hostname;

export const serverBaseWebSocketUrl =
  (process.env.REACT_APP_SERVER_WEBSOCKET_PROTOCOL || 'wss') + '://' + serverBaseUrl;
